import { useEffect, useState } from "react";
import { Col, Row, Typography, Divider } from "antd";
import FileUploadComponent, { FileData } from "../../../components/FileUploadComponent";
import InputComponent from "../../../components/InputComponent";
import { FileUploadItems, InputStyle, labelStyle } from "./constants";
import SwitchOptionComponent from "../../../components/SwitchComponent";
import { useNewsContext } from "../../../context/NewsContext/NewsContext";
import RichTextComponent from "../../../components/RichTextComponent";
import TextareaComponent from "../../../components/TextareaComponent";
import { DefaultImageList } from "../../../context/NewsContext/constants";

type NewsContentDetailProps = {
  isEnContent: boolean;
};

const NewsContentDetail: React.FC<NewsContentDetailProps> = ({ isEnContent }) => {
  const NEWS_DETAIL_INDEX = isEnContent ? 1 : 0;
  const { newsData, setNewsData, defaultImageList, loadingGetNewsData, activeSameImages, setActiveSameImages } = useNewsContext();
  const [messageTemplate, setMessageTemplate] = useState("");
  const [shortNewsText, setShortNewsText] = useState("");

  const handleFileChange = (fileData: FileData | null, key: string) => {
    setNewsData(prevState => {
      return {
        ...prevState,
        newsDetail: prevState.newsDetail.map((item, idx) => {
          if (idx === NEWS_DETAIL_INDEX) {
            return {
              ...item,
              [key]: fileData?.file
            };
          }
          return item;
        })
      };
    });
  };

  const handleTitleChange = (value: string) => {
    setNewsData(prevState => {
      return {
        ...prevState,
        newsDetail: prevState.newsDetail.map((item, idx) => {
          if (idx === NEWS_DETAIL_INDEX) {
            return {
              ...item,
              title: value
            };
          }
          return item;
        })
      };
    });
  };

  const handleSetChangedTemplate = (body: string) => {
    setMessageTemplate(body);
  };

  useEffect(() => {
    setNewsData(prevState => {
      return {
        ...prevState,
        newsDetail: prevState.newsDetail.map((item, idx) => {
          if (idx === NEWS_DETAIL_INDEX) {
            return {
              ...item,
              shorText: shortNewsText
            };
          }
          return item;
        })
      };
    });
  }, [shortNewsText]);

  useEffect(() => {
    setNewsData(prevState => {
      return {
        ...prevState,
        newsDetail: prevState.newsDetail.map((item, idx) => {
          if (idx === NEWS_DETAIL_INDEX) {
            return {
              ...item,
              text: messageTemplate
            };
          }
          return item;
        })
      };
    });
  }, [messageTemplate]);

  useEffect(() => {
    if (!loadingGetNewsData)
      setMessageTemplate(newsData?.newsDetail[NEWS_DETAIL_INDEX]?.text ?? "");
  }, [loadingGetNewsData]);

  useEffect(() => {
    setNewsData(prevState => {
      const updatedNewsDetail = prevState.newsDetail.map(detail => {
        if (detail.culture === "en-US" && !activeSameImages) {
          return {
            ...detail,
            imageUrl: null,
            smallImageUrl: null,
            mobileImageUrl: null,
            mobileSmallImageUrl: null
          };
        }
        return detail;
      });

      return {
        ...prevState,
        activeSameImages: activeSameImages,
        newsDetail: updatedNewsDetail
      };
    });
  }, [activeSameImages]);

  return (
    <>
      {isEnContent &&
        <SwitchOptionComponent
          labelStyle={labelStyle}
          key={"sameImages"}
          title={"Aynı görseller kullanılsın"}
          value={activeSameImages}
          onChange={(checked) =>
            setActiveSameImages(checked)
          }
        />
      }
      <Row gutter={20}>
        {!activeSameImages && FileUploadItems.map((item) => (
          <Col key={item.key} span={6} style={{
            minHeight:"438px",
            display: "flex",
            width: "25%",
            }}>
            <FileUploadComponent
              title={item.label}
              onChange={(fileData: FileData | null) => handleFileChange(fileData, item.key)}
              dimensions={item.dimensions}
              fileSize={item.fileSize}
              fileSizeText={item.fileSizeText}
              format={item.format}
              defaultValue={defaultImageList[NEWS_DETAIL_INDEX][item.key as keyof DefaultImageList] as string | null}
            />
          </Col>
        ))}
      </Row>
      <Divider />
      <Row gutter={20}>
        <Col span={12}>
          <InputComponent
            title={"Başlık"}
            placeholder=""
            value={newsData?.newsDetail[NEWS_DETAIL_INDEX]?.title}
            style={InputStyle}
            isRequired
            onChange={(e) => handleTitleChange(e.target.value)}
          />
        </Col>
      </Row>
      <Row gutter={20}>
        <Col span={12}>
          <TextareaComponent
            title={"Kısa Metin"}
            placeholder=""
            value={newsData?.newsDetail[NEWS_DETAIL_INDEX]?.shorText}
            isRequired
            onChange={(e) => setShortNewsText(e.target.value)}
            rows={20}
          />
        </Col>
        <Col span={12}>
          <Typography.Title level={5} style={{ color: "#2e333e" }}>
            Uzun Metin
            <span style={{ color: "red" }}>&nbsp;*</span>
          </Typography.Title>

          <RichTextComponent
            messageTemplate={messageTemplate}
            handleSetChangedTemplate={handleSetChangedTemplate}
          />
        </Col>
      </Row>
    </>
  );
};

export default NewsContentDetail;
